import React from 'react';
import classnames from 'classnames';
import { ConfigContext } from '../config-provider';
import ColumnItem from './ColumnItem';
const Column = (props) => {
    const { title, icon, style, className, children } = props;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('footer-column');
    const cls = classnames(prefixCls, className);
    return (React.createElement("div", { className: cls, style: style },
        (title || icon) && (React.createElement("h2", null,
            icon && React.createElement("span", { className: `${prefixCls}-icon` }, icon),
            title)),
        children));
};
Column.Item = ColumnItem;
export default Column;
